import { createContext, FC, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { SearchParameters, useSearchParameters } from '../useSearchParameters'

interface ReferrerContext {
  source?: string
  setSource: (source?: string) => void
}

const context = createContext<ReferrerContext>({
  setSource: () => undefined,
})
const { Provider } = context

const ReferrerProvider: FC = ({ children }) => {
  const { [SearchParameters.UTM_SOURCE]: searchParamUtmSource } = useSearchParameters()
  const [source, setSource] = useState<string | undefined>()

  useEffect(() => {
    if (typeof searchParamUtmSource === 'string') {
      setSource(searchParamUtmSource)
    }
  }, [searchParamUtmSource])

  const setSourceProxy = useCallback((source?: string) => {
    setSource(source)
  }, [])

  const value: ReferrerContext = useMemo(() => ({ source, setSource: setSourceProxy }), [source, setSourceProxy])

  return <Provider value={value}>{children}</Provider>
}

const useReferrerContext = () => useContext(context)

export { ReferrerProvider, useReferrerContext }
export type { ReferrerContext }
